import { Component, Input, NgZone, OnInit } from '@angular/core';
import { Users } from 'server/shared/collections/users';
import { Customer } from 'server/shared/models/customer';
import { JobRequestInvitee } from 'server/shared/models/job-request';
import { RoleEnum } from 'server/shared/models/role.enum';
import { SexEnum } from 'server/shared/models/sex.enum';
import { PoolerUser } from 'server/shared/models/user';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'app-job-request-invitee',
  templateUrl: 'job-request-invitee.component.html',
  styleUrls: ['job-request-invitee.component.scss'],
})
export class JobRequestInviteeComponent implements OnInit {
  @Input() invitee?: JobRequestInvitee;
  @Input() isCanceled?: boolean;
  @Input() loggedInCustomer?: Customer;
  @Input() jobId?: string;
  @Input() uncollapsable: boolean = false;

  user?: PoolerUser;
  showDetails: boolean = false;
  detailCollapseTimeout = setTimeout(() => {});
  rotateChevron: boolean = false;
  animationShowDetails: boolean = false;
  sexEnum = SexEnum;
  roleEnum = RoleEnum;

  loggedInUser$ = this.userService.readyUser$;

  constructor(private ngZone: NgZone, public userService: UserService) {}

  ngOnInit(): void {
    Tracker.autorun(() => {
      this.ngZone.run(() => {
        this.user = Users.findOne(this.invitee?.userId) as PoolerUser;
      });
    });
  }

  toggleDetails(event: Event) {
    event.preventDefault();
    clearTimeout(this.detailCollapseTimeout);
    this.rotateChevron = !this.rotateChevron;
    if (!this.rotateChevron) {
      this.animationShowDetails = false;
      // un-render elements after animation delay
      this.detailCollapseTimeout = setTimeout(() => {
        this.showDetails = false;
      }, 300);
    } else {
      this.showDetails = true;
      // start animation immediately after rendering elements
      setTimeout(() => {
        this.animationShowDetails = true;
      });
    }
  }
}
